/*
 * Lib Module Responsives
 */

Lib.Responsive = (function() {
    var self = {};
    var _self = {};
    var helperContainer;
    var hasHelperDiv = false;

    _self.createHelper = function() {
        if (hasHelperDiv === false) {
            helperContainer = $("<div />").attr('id', 'lib-responsives');

            $('<span />').attr({
                id: 'xs',
                class: 'hidden-sm-up'
            }).appendTo(helperContainer);

            $('<span />').attr({
                id: 'sm',
                class: 'hidden-xs hidden-md-up'
            }).appendTo(helperContainer);

            $('<span />').attr({
                id: 'md',
                class: 'hidden-md-down hidden-lg-up'
            }).appendTo(helperContainer);

            $('<span />').attr({
                id: 'lg',
                class: 'hidden-lg-down hidden-xl'
            }).appendTo(helperContainer);

            $('<span />').attr({
                id: 'xl',
                class: 'hidden-xl-down'
            }).appendTo(helperContainer);

            $("body").append(helperContainer);

            hasHelperDiv = true;
        }
    };

    self.is = function(bp) {
        _self.createHelper();
        if (typeof bp === 'object') {
            var isBp = false;
            $.each(bp, function(i, breakpoint) {
                if (self.checkBP(breakpoint)) {
                    isBp = true;
                }
            });
            return isBp;
        } else {
            return self.checkBP(bp);
        }
    };

    self.checkBP = function(bp) {
        _self.createHelper();
        switch (bp.toLowerCase()) {
            case 'xl':
                return helperContainer.find('#xl').is(':visible');
            case 'lg':
                return helperContainer.find('#lg').is(':visible');
            case 'md':
                return helperContainer.find('#md').is(':visible');
            case 'sm':
                return helperContainer.find('#sm').is(':visible');
            case 'xs':
                return helperContainer.find('#xs').is(':visible');
        }
        return null;
    };


    self.getBP = function() {
        _self.createHelper();
        return helperContainer.find(':visible').attr('id');
    };

    return self;

})();
